import { SupportTicketAttachmentParamsContentTypeEnum } from "@rentablo/api/apiv1";

export const MAX_ATTACHMENTS = 3;

export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

// Browsers read File.type from the OS registry, which has no entry for
// QuickTime on many systems and then reports "". Matching the extension as
// well keeps those files acceptable, and lets the file picker list them.
export const CONTENT_TYPE_EXTENSIONS: Record<
  SupportTicketAttachmentParamsContentTypeEnum,
  string[]
> = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
  "video/mp4": [".mp4"],
  "video/quicktime": [".mov"],
  "video/webm": [".webm"],
  "application/pdf": [".pdf"],
};

export const SUMMARY_PREFIX = "Problembericht: ";

export const MAX_SUMMARY_LENGTH = 255;

export const MAX_BANK_LENGTH = 255;

export const MAX_ISIN_LENGTH = 50;

export const MAX_STEPS_TO_REPRODUCE_LENGTH = 10000;

export const MAX_ERROR_CODE_OR_URL_LENGTH = 2000;
